<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Equipment Historical Records
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer>

    <form [formGroup]="searchForm">
        <div class="flex justify-between items-center w-full mb-3">
            <div class="text-xl font-medium">
                {{ data.valveName == 'WRSV' ? 'Retrievable Valve / Plug' : data.valveName == 'TR-SSSV' ? 'TRSCSSV' :
                data.valveName }}
            </div>
            <div class="flex justify-around">
                <div class="w-17 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button class="btn btn-outline" matTooltip="Download" (click)="downloadEquipmentRegHistoricalRecords()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-equipment-historical-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            [ngClass]="{
            'xmastree-column': data.valveType === 'XMT', 
            'annulusValve-column' :  ['PCV','ICV','SCV','CCV'].includes(data.valveType),
            'valve-column' :  ['CV', 'KWV', 'LMV', 'WV'].includes(data.valveType),
            'trsv-column' : data.valveType === 'TRSV',
            'wrsv-column' : data.valveType === 'WRSV',
            'ssv-column' : data.valveType === 'SSV'
            }" matSort matSortDisableClear>

            <div class="border py-8 text-center">
                No
            </div>

            <ng-container *ngIf="data.valveType !== 'WRSV'">
                <div [mat-sort-header]="'installedDate'" class="flex justify-center border py-4 my-custom-sort-header">
                    Installed Date
                </div>

                <div [mat-sort-header]="'partNo'" class="flex justify-center border py-4">
                    Part Number
                </div>

                <div [mat-sort-header]="'sizeIn'" class="flex justify-center border py-4">
                    Size (inch)
                </div>

                <div [mat-sort-header]="'equipmentBrand'" class="flex justify-center border py-4">
                    Equipment Brand / OEM
                </div>

                <div [mat-sort-header]="'ratingPsi'" class="flex border justify-center py-4">
                    Rating (psi)
                </div>
            </ng-container>


            <ng-container *ngIf="data.valveType === 'XMT'">
                <div [mat-sort-header]="'model'" class="flex border justify-center py-4">
                    Model
                </div>

                <div [mat-sort-header]="'remark'" class="flex border justify-center py-4">
                    Remarks
                </div>
            </ng-container>

            <ng-container *ngIf="['PCV','ICV','SCV','CCV'].includes(data.valveType)">
                <div [mat-sort-header]="'actuatorType'" class="flex border justify-center py-4">
                    AVR Installed
                </div>
            </ng-container>

            <ng-container *ngIf="['CV', 'KWV', 'LMV', 'SSV', 'WV', 'PCV','ICV','SCV','CCV'].includes(data.valveType)">
                <!-- <div [mat-sort-header]="'isActuated'" class="flex border justify-center py-4">
                    Type
                </div> -->

                <div [mat-sort-header]="'actuatorType'" class="flex border justify-center py-4">
                    Actuator Type
                </div>

                <div [mat-sort-header]="'actuatorModel'" class="flex border justify-center py-4">
                    Actuator Model
                </div>

                <div [mat-sort-header]="'openingSec'" class="flex border justify-center py-4">
                    Opening (sec)
                </div>

                <div [mat-sort-header]="'openingCm'" class="flex border justify-center py-4">
                    Opening (cm)
                </div>

                <div [mat-sort-header]="'closingSec'" class="flex border justify-center py-4">
                    Closing (sec)
                </div>

                <div [mat-sort-header]="'closingCm'" class="flex border justify-center py-4">
                    Closing (cm)
                </div>

                <ng-container *ngIf="data.valveType != 'SSV'">
                    <div [mat-sort-header]="'fullyOpen'" class="flex border justify-center py-4">
                        Fully Open
                    </div>

                    <div [mat-sort-header]="'fullyClose'" class="flex border justify-center py-4">
                        Fully Close
                    </div>
                </ng-container>

                <div [mat-sort-header]="'hydraulicReturn'" class="flex border justify-center py-4">
                    Hydraulic Return
                </div>

                <!-- <div [mat-sort-header]="'jammed'" class="flex border justify-center py-4">
                    Jammed
                </div> -->
            </ng-container>


            <ng-container *ngIf="data.valveType === 'TRSV'">
                <div [mat-sort-header]="'isSelfEqualize'" class="flex border justify-center py-4">
                    Self Equalizing
                </div>

                <div [mat-sort-header]="'isLockedOpen'" class="flex border justify-center py-4">
                    Locked-Open
                </div>
            </ng-container>

            <ng-container *ngIf="data.valveType === 'WRSV'">
                <div [mat-sort-header]="'initialInstalledDate'" class="flex border justify-center py-4">
                    Initial Installed Date
                </div>

                <div [mat-sort-header]="'latestInstalledDate'" class="flex border justify-center py-4">
                    Latest Installed Date
                </div>

                <div [mat-sort-header]="'partNo'" class="flex border justify-center py-4">
                    Part Number
                </div>

                <div [mat-sort-header]="'trsvType'" class="flex border justify-center py-4">
                    Type of Retrievable Valve / Plug
                </div>

                <div [mat-sort-header]="'sizeIn'" class="flex border justify-center py-4">
                    Size (inch)
                </div>

                <div [mat-sort-header]="'subsequentInstalledDate'" class="flex border justify-center py-4">
                    Subsequent Installed Date
                </div>

                <div [mat-sort-header]="'equipmentBrand'" class="flex border justify-center py-4">
                    Equipment Brand / OEM
                </div>

                <div [mat-sort-header]="'ratingPsi'" class="flex border justify-center py-4">
                    Rating (psi)
                </div>

                <!-- <div [mat-sort-header]="'oem'" class="flex border justify-center py-4">
                    OEM
                </div> -->

                <div [mat-sort-header]="'model'" class="flex border justify-center py-4">
                    Model
                </div>

                <div [mat-sort-header]="'installationDepth'" class="flex border justify-center py-4">
                    Installation Depth
                </div>

                <div [mat-sort-header]="'installationAtSvlntrsv'" class="flex border justify-center py-4">
                    Location
                </div>

                <div [mat-sort-header]="'remark'" class="flex border justify-center py-4">
                    Remark
                </div>
            </ng-container>

            <div class="flex border justify-center py-8">
                Action
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-equipment-historical-record-grid grid items-center border-b" [ngClass]="{'bg-primary-100': i % 2,
                            'xmastree-column': data.valveType === 'XMT', 
                            'annulusValve-column' :  ['PCV','ICV','SCV','CCV'].includes(data.valveType),
                            'valve-column' :  ['CV', 'KWV', 'LMV', 'WV'].includes(data.valveType),
                            'trsv-column' : data.valveType === 'TRSV',
                            'wrsv-column' : data.valveType === 'WRSV',
                            'ssv-column' : data.valveType === 'SSV'}">
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <ng-container *ngIf="data.valveType !== 'WRSV'">

                        <!-- Installed Date -->
                        <div class="flex truncate justify-center">
                            {{ handleFormatDate(row.installedDate, false) }}
                        </div>

                        <!-- Part Number  -->
                        <div class="flex justify-center">
                            {{ row.partNo || '-'}}
                        </div>

                        <!-- Size  -->
                        <div class="flex justify-center">
                            {{ row.sizeIn || '-' }}
                        </div>

                        <!-- Equipment Brand  -->
                        <div class="text-center">
                            {{ row.equipmentBrand || '-' }}
                        </div>

                        <!-- OEM -->
                        <!-- <div class="block text-center">
                            {{ row.oem || '-' }}
                        </div> -->

                        <!-- Rating (PSI)-->
                        <div class="block text-center">
                            {{ row.ratingPsi || '-' }}
                        </div>
                    </ng-container>

                    <ng-container *ngIf="data.valveType === 'XMT'">
                        <!-- Model -->
                        <div class="block text-center">
                            {{ row.model || '-' }}
                        </div>

                        <!-- Remarks -->
                        <div class="block text-center">
                            {{ row.remark || '-' }}
                        </div>
                    </ng-container>

                    <ng-container *ngIf="['PCV','ICV','SCV','CCV'].includes(data.valveType)">
                        <!-- AVR Installed -->
                        <div class="block text-center">
                            {{ row.isAvrInstalled ? 'Yes' : 'No' || '-' }}
                        </div>
                    </ng-container>

                    <ng-container
                        *ngIf="['CV', 'KWV', 'LMV', 'SSV', 'WV', 'PCV','ICV','SCV','CCV'].includes(data.valveType)">
                        <!-- Actuator Type -->
                        <div class="block text-center">
                            {{ row.actuatorType || '-' }}
                        </div>

                        <!-- Actuator Model -->
                        <div class="block text-center">
                            {{ row.actuatorModel || '-' }}
                        </div>

                        <!-- Opening (sec) -->
                        <div class="block text-center">
                            {{ row.openingSec || '-' }}
                        </div>

                        <!-- Opening (cm) -->
                        <div class="block text-center">
                            {{ row.openingCm || '-' }}
                        </div>

                        <!-- Closing (sec) -->
                        <div class="block text-center">
                            {{ row.closingSec || '-' }}
                        </div>

                        <!-- Closing (cm) -->
                        <div class="block text-center">
                            {{ row.closingCm || '-' }}
                        </div>

                        <ng-container *ngIf="data.valveType != 'SSV'">
                            <!-- Fully Open -->
                            <div class="block text-center">
                                {{ row.fullyOpen || '-' }}
                            </div>

                            <!-- Fully Close -->
                            <div class="block text-center">
                                {{ row.fullyClose || '-' }}
                            </div>
                        </ng-container>

                        <!-- Hydraulic return -->
                        <div class="block text-center">
                            {{ row.hydraulicReturn || '-' }}
                        </div>

                        <!-- Jammed -->
                        <!-- <div class="block text-center">
                            {{ row.jammed || '-' }}
                        </div> -->

                    </ng-container>

                    <ng-container *ngIf="data.valveType === 'TRSV'">
                        <!-- isSelfEqualize -->
                        <div class="block text-center">
                            {{ row.isSelfEqualize ? 'Yes' : 'No' }}
                        </div>

                        <!-- isLockedOpen -->
                        <div class="block text-center">
                            {{ row.isLockedOpen ? 'Yes' : 'No' }}
                        </div>
                    </ng-container>

                    <ng-container *ngIf="data.valveType === 'WRSV'">
                        <!-- Initial Installed Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.initialInstalledDate,false) }}
                        </div>

                        <!-- Latest Installed Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.latestInstalledDate,false) }}
                        </div>

                        <!-- Part No -->
                        <div class="block text-center">
                            {{ row.partNo }}
                        </div>

                        <!-- Type of WRSV -->
                        <div class="block text-center">
                            {{ row.trsvType }}
                        </div>

                        <!-- size -->
                        <div class="block text-center">
                            {{ row.sizeIn }}
                        </div>

                        <!-- subsequent installed date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.subsequentInstalledDate,false) }}
                        </div>

                        <!-- equipment brand -->
                        <div class="block text-center">
                            {{ row.equipmentBrand }}
                        </div>

                        <!-- rating -->
                        <div class="block text-center">
                            {{ row.ratingPsi }}
                        </div>

                        <!-- oem -->
                        <!-- <div class="block text-center">
                            {{ row.oem }}
                        </div> -->

                        <!-- model -->
                        <div class="block text-center">
                            {{ row.model }}
                        </div>

                        <!-- installation depth -->
                        <div class="block text-center">
                            {{ row.installationDepth }}
                        </div>

                        <!-- installed at svln/trsv -->
                        <div class="block text-center">
                            {{ row.installationAtSvlntrsv }}
                        </div>

                        <!-- remark -->
                        <div class="block text-center">
                            {{ row.remark || '-'}}
                        </div>


                    </ng-container>

                    <!-- Action -->
                    <div class="block text-center">
                        <button class="btn btn-remove-bg" (click)="updateHistoricalRecords(row, data.valveName)">
                            <mat-icon class="text-primary" svgIcon="heroicons_solid:pencil-square"></mat-icon>
                        </button>

                        <button class="btn btn-remove-bg" (click)="deleteHistoricalRecords(row)">
                            <mat-icon style="color:rgb(232, 88, 88)" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
</mat-dialog-content>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>